import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e387ae3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "home_content" }
const _hoisted_3 = { class: "form_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span", { class: "tips-text" }, "表格任意单元格双击均可自动复制（仅支持高版本浏览器）")
], -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("未支付")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("已支付")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_12 = { class: "pages" }

import { ref, onMounted, reactive } from 'vue'
  import Menu from '../../components/Menu.vue'
  import {GETAuth} from '@/service/index'
  import { useRouter } from 'vue-router'
  import {ElMessage} from "element-plus";
  import useClipboard from "vue-clipboard3";
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const router = useRouter();
  const loading = ref(false)

  const workCodes:any = ref([
    { label: '总部', value: "00" },
    { label: '北门路', value: "01" },
    { label: '正仪', value: "02" },
    { label: '太湖路', value: "03" },
    { label: '张浦', value: "04" },
    { label: '网站', value: "web" }
  ])


  const recordBase:any = ref([])
  onMounted(() => {
    getRecord()
  })

  const { toClipboard } = useClipboard()
  const copyInfoHandler = (row:any, cell:any) => {
    copyInfo(row[cell.property])
  }

  const copyInfo = async (str:string) => {
    try {
      await toClipboard(str)
      ElMessage.success('复制成功')
    } catch (e) {
      ElMessage.error('复制失败')
    }
  }

  const resetForm = () => {
    params.studentname = ''
    params.idcardno = ''
    params.companyname = ''
    params.phoneno = ''
    params.workcode = ''
    params.index = 1
    getRecord()
  }

  const params = reactive({
    studentname: '',
    idcardno: '',
    companyname: '',
    phoneno: '',
    errollstatus: 'APPROVED',
    workcode: '',
    index: 1,
    pageSize: 15
  })

  const pagesValue = ref(0)
  const totalValue = ref(0)

  const getRecord = async () => {
    loading.value = true
    let { data } = await GETAuth(`/api/enroll_record_list`, {
      params
    })
    loading.value = false
    if ( data.code === 200 ) {
      let { records, pages, total } = data.data
      recordBase.value =records
      pagesValue.value = pages
      totalValue.value = total
    }
  }

  const goPaidResult = (item:any) => {
    router.push({
      name: 'PaidResult',
      params: {
        record: item.recordcode
      }
    })
  }

  
  const currentChangeHandler = (e:string) => {
    params.index = e
    getRecord()
  }


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Menu, { index: "3" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          inline: true,
          model: _unref(params),
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "学员姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).studentname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(params).studentname) = $event)),
                  style: {"width":"100px"},
                  clearable: "",
                  placeholder: "学员姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "身份证号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).idcardno,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(params).idcardno) = $event)),
                  clearable: "",
                  placeholder: "请输入身份证号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公司名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).companyname,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(params).companyname) = $event)),
                  style: {"width":"150px"},
                  clearable: "",
                  placeholder: "请输入公司名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "联系电话" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(params).phoneno,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(params).phoneno) = $event)),
                  style: {"width":"120px"},
                  clearable: "",
                  placeholder: "请输入联系电话"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "报名渠道" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(params).workcode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(params).workcode) = $event)),
                  style: {"width":"100px"},
                  clearable: "",
                  placeholder: "选择报名渠道"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workCodes.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: getRecord
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: resetForm }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _hoisted_6,
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: recordBase.value,
        stripe: "",
        onCellDblclick: copyInfoHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "createdatetime",
            width: "180",
            label: "报名日期"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "studentname",
            width: "80",
            label: "姓名"
          }),
          _createVNode(_component_el_table_column, {
            prop: "idcardno",
            width: "180",
            label: "证件号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "coursename",
            width: "200",
            label: "报名课程"
          }),
          _createVNode(_component_el_table_column, {
            prop: "stagename",
            width: "80",
            label: "培训项目"
          }),
          _createVNode(_component_el_table_column, {
            prop: "companyname",
            width: "300",
            label: "公司名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "paytime",
            width: "200",
            label: "支付日期"
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoiceremark",
            width: "170",
            label: "发票备注"
          }),
          _createVNode(_component_el_table_column, {
            prop: "nameremark",
            width: "170",
            label: "备注"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            prop: "errollstatus",
            width: "100",
            label: "支付状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.errollstatus === 'INITIAL')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.errollstatus === 'APPROVED')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.errollstatus === 'REJECT')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (scope.row.errollstatus === 'PAID')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            prop: "workcode",
            width: "80",
            label: "报名渠道"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            prop: "errollstatus",
            width: "100",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "text",
                size: "small",
                onClick: ($event: any) => (goPaidResult(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_pagination, {
          background: "",
          "hide-on-single-page": true,
          layout: "prev, pager, next",
          "current-page": _unref(params).index,
          "page-size": _unref(params).pageSize,
          total: totalValue.value,
          onCurrentChange: currentChangeHandler
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ])
  ]))
}
}

})